import React, { useMemo } from 'react';
import { pricingItemList } from '../data';
import PricingItem from '../PricingItem';

export default function PricingList() {
  const pricingList = useMemo(
    () =>
      pricingItemList.map((pricingItem) => (
        <PricingItem key={pricingItem.title} pricingItem={pricingItem} />
      )),
    []
  );

  return <div className="pricing__list-item">{pricingList}</div>;
}
